import { useTranslations } from "use-intl";

import { errorKey, retryAfter } from "../webhooks.utils";

// One line in the page's own words for every refusal the webhook routes give.
export function WebhookErrorText({ error }: { error: unknown }) {
	const t = useTranslations("webhooks.errors");
	const key = errorKey(error);
	const seconds = retryAfter(error);
	let text: string;
	if (key !== "tooSoon") text = t(key);
	else text = seconds === null ? t("generic") : t("tooSoon", { seconds });
	return (
		<p role="alert" className="text-destructive text-sm">
			{text}
		</p>
	);
}
